import { scrubText } from './redact';

export const SESSION_IDLE_MS = 30 * 60 * 1000;
export const ACTIVE_IDLE_MS = 60 * 1000;
/** Campaign/goal identifiers are configured slugs, never arbitrary user input. */
export function safeDimension(value: unknown): string | undefined {
  if (typeof value !== 'string' || !/^[a-zA-Z][a-zA-Z0-9_-]{0,39}$/.test(value)) return;
  if (/\d{6}|[a-f0-9]{20}/i.test(value) || scrubText(value, 40) !== value) return;
  return value.toLowerCase();
}
export function acquisition(url: string, referrer: string): Record<string, string> {
  const result: Record<string, string> = { referrer: '', referrerStatus: 'direct' };
  if (referrer) {
    try {
      const parsed = new URL(referrer);
      if (!['https:', 'http:'].includes(parsed.protocol)) throw new Error('Unsupported');
      result.referrer = parsed.origin;
      result.referrerStatus = 'known';
    } catch { result.referrerStatus = 'unknown'; }
  }
  try {
    const params = new URL(url).searchParams;
    for (const [source, target] of [['utm_source', 'campaign_source'], ['utm_medium', 'campaign_medium'], ['utm_campaign', 'campaign_name']]) {
      const value = safeDimension(params.get(source));
      if (value) result[target] = value;
    }
  } catch { /* Invalid URLs have no acquisition dimensions. */ }
  return result;
}
export function sessionExpired(lastActivity: number, now: number): boolean {
  return !Number.isFinite(lastActivity) || lastActivity <= 0 || now < lastActivity || now - lastActivity >= SESSION_IDLE_MS;
}
export function activeDelta(previous: number, now: number, lastInteraction: number, allowed: boolean): number {
  if (!allowed || previous <= 0 || now < previous) return 0;
  return Math.max(0, Math.min(now, lastInteraction + ACTIVE_IDLE_MS) - previous);
}
